const apiErrorMappings = {
  start_address_id: { 'invalid value': 'Data telah dihapus dari sistem.' },
  end_address_id: { 'invalid value': 'Data telah dihapus dari sistem.' },
  completed_on: {
    'value cant be less than with actual_departure_on':
      'Waktu Pengambilan tidak boleh kurang dari Waktu Keberangkatan Aktual',
  },
  vehicle_id: {
    'already used': 'Kendaraan telah terpakai pada pengiriman lain.',
    'invalid value': 'Kendaraan tidak ada di Data Master Kendaraan.',
    'vehicle status invalid': 'Status kendaraan tidak aktif',
    'vehicle box type different': 'Jenis box kendaraan tidak sesuai dengan muatan',
    'vehicle not found in customer contract': 'Kendaraan tidak tersedia pada kontrak pelanggan',
    'vehicle does not match customer contract vehicle type':
      'Kendaraan tidak sesuai dengan jenis kendaraan pada kontrak pelanggan',
  },
  driver_user_id: {
    'already used': `Pengemudi utama telah terpakai pada pengiriman lain.`,
    'invalid value': `Pengemudi utama tidak ada di Data Master Pengemudi.`,
    'driver user group invalid': `Pengemudi utama tidak ditemukan`,
  },
  driver_user_2_id: {
    'already used': 'Pengemudi Tambahan telah terpakai pada pengiriman lain.',
    'invalid value': 'Pengemudi Tambahan tidak ada di Data Master Pengemudi.',
    'driver user group invalid': 'Pengemudi Tambahan tidak ditemukan',
  },
  user_group_id: {
    'user group is required': 'User group harus diisi',
  },
  auto_start_failed_reason: {
    VEHICLE_CONFLICT: 'Kendaraan telah terpakai pada pengiriman lain',
  },
  box_type_id: {
    'invalid value': 'Jenis box tidak ditemukan.',
  },
  contract_type: {
    'contract_type not found in customer contract':
      'Jenis kontrak tidak tersedia pada kontrak pelanggan',
  },
  vehicle_category_name: {
    'vehicle category not found in customer contract':
      'Kategori kendaraan tidak tersedia pada kontrak pelanggan',
  },
  vehicle_type_id: {
    'vehicle type not found in customer contract':
      'Jenis kendaraan tidak tersedia pada kontrak pelanggan',
    'vehicle type does not match customer contract vehicle category':
      'Jenis kendaraan tidak sesuai dengan kategori kendaraan pada kontrak pelanggan',
  },
}

export default apiErrorMappings
